<template>
  <div>
    <!-- Institution Type -->
    <div class="columns">
      <div class="column is-two-thirds">
        <l-field
          :label="$t('compTransitionMapsFiltersitemsCampus.field-types')"
          :tooltip="$t('compTransitionMapsFiltersitemsCampus.tooltip-types')"
          label-position="on-border"
        >
          <b-taginput
            field="name"
            name="types"
            icon="university"
            :data="filteredTypes"
            :allow-new="false"
            rounded
            v-model="filters.types"
            :placeholder="
              $t('compTransitionMapsFiltersitemsCampus.select-types')
            "
            :open-on-focus="true"
            @input="inputChanged"
            @typing="getFilteredTypes"
            autocomplete
            clearable
          >
            <template slot-scope="props">
              {{ props.option.name }}
            </template>
          </b-taginput>
        </l-field>
      </div>
      <div class="column"></div>
    </div>
    <!-- Domains-->
    <div class="columns">
      <div class="column">
        <l-field
          :label="$t('compTransitionMapsFiltersitemsCampus.field-domains')"
          :tooltip="$t('compTransitionMapsFiltersitemsCampus.tooltip-domains')"
          label-position="on-border"
        >
          <b-taginput
            field="name"
            name="domains"
            icon="hubzilla"
            :data="filteredDomains"
            :allow-new="false"
            rounded
            v-model="filters.domains"
            :placeholder="
              $t('compTransitionMapsFiltersitemsCampus.select-domains')
            "
            :open-on-focus="true"
            @input="inputChanged"
            @typing="getFilteredDomains"
            autocomplete
            clearable
          >
            <template slot-scope="props">
              {{ props.option.name }}
            </template>
          </b-taginput>
        </l-field>
      </div>
      <div class="column is-one-third">
        <div class="block">
          <l-field
            label=""
            :tooltip="
              $t('compTransitionMapsFiltersitemsCampus.tooltip-domains-op')
            "
            label-position="on-border"
          >
            <b-radio-button
              @input="inputChanged"
              v-model="filters.domainsOp"
              size="is-small"
              native-value="AND"
            >
              {{ $t('compTransitionMapsFiltersitemsCampus.filter:and') }}
            </b-radio-button>
            <b-radio-button
              @input="inputChanged"
              v-model="filters.domainsOp"
              size="is-small"
              native-value="OR"
            >
              {{ $t('compTransitionMapsFiltersitemsCampus.filter:or') }}
            </b-radio-button>
          </l-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import coreService from '@/services/coreService'

export default {
  name: 'FiltersCampus',
  components: {
    'l-field': () => import('@/components/LField.vue')
  },
  data: function () {
    return {
      filters: {
        domains: [],
        domainsOp: 'AND',
        types: []
      },
      domains: [],
      types: [],
      filteredDomains: [],
      filteredTypes: []
    }
  },
  methods: {
    inputChanged () {
      this.$emit('filterChanged', this.filters)
    },
    getFilteredDomains (text) {
      this.filteredDomains = this.domains.filter((option) => {
        return (
          option.name.toString().toLowerCase().indexOf(text.toLowerCase()) >= 0
        )
      })
    },
    getFilteredTypes (text) {
      this.filteredTypes = this.types.filter((option) => {
        return (
          option.name.toString().toLowerCase().indexOf(text.toLowerCase()) >= 0
        )
      })
    }
  },
  mounted () {
    coreService.getDomains().then((data) => {
      this.domains = data
      this.filteredDomains = data
    })
    coreService.getInstitutionTypes().then((data) => {
      this.types = data
      this.filteredTypes = data
    })
  }
}
</script>
